const gerar_arquivo_de_migracao_do_censo_escolar = [
  {
    path: "/gerar-arquivo-de-migracao-do-censo-escolar",
    name: "gerar_arquivo_de_migracao_do_censo_escolar",
    meta: {
      breadCrumb: "Censo Escolar - Migração do Censo Escolar",
      allowedPermissions: ["migracao_censo_arquivo"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoDeMigracaoDoCensoEscolar/GerarArquivoDeMigracaoDoCensoEscolar.vue"
      ),
  },
];

export { gerar_arquivo_de_migracao_do_censo_escolar };
